<template>
  <div class="zoomInContainer">
    <home-floating-window :title="$tc('Detail', 2)" @close="close">
      <template v-slot:iconWindows>
        <v-icon size="30" style="margin: 0 10px !important;">zoom_in</v-icon>
      </template>

      <template v-slot:objectDivWindows>
        <network-diagram-node
          v-if="type === 'node'"
          :node-type="nodeType"
          :node-data="objectData"
          :zoom-in="true"
          class="details-network-diagram"
        />
        <network-diagram-cable
          v-if="type === 'cable'"
          :cable-data="objectData"
          :zoom-in="true"
          class="details-network-diagram"
        />
      </template>
    </home-floating-window>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";
import NetworkDiagramNode from "./NetworkDiagram/NetworkDiagramNode";
import NetworkDiagramCable from "./NetworkDiagram/NetworkDiagramCable";
import HomeFloatingWindow from "@/components/Home/Content/ObjectWindow/HomeFloatingWindow";

export default {
  name: "NetworkDiagramZoomIn",

  components: {
    HomeFloatingWindow,
    NetworkDiagramCable,
    NetworkDiagramNode,
    WindowHeaderButton
  },

  data() {
    return {
      type: undefined,
      nodeType: undefined,
      objectData: undefined
    };
  },

  computed: {
    ...mapState({
      update: state => state.networkDiagram.zoomIn.update,

      selectedObjectInfo: state => state.networkDiagram.selectedObject
    })
  },

  created() {
    this.getZoomInInfo();
  },

  methods: {
    ...mapActions(["TOGGLE_NETWORK_DIAGRAM_ZOOM_IN"]),

    /**
     * Obtains the Zoom In info from the store and stores it locally.
     */
    getZoomInInfo() {
      let zoomInInfo = this.selectedObjectInfo;
      this.type = zoomInInfo.type;
      this.objectData = zoomInInfo.objectData;
      if (this.type === "node") {
        this.nodeType = zoomInInfo.nodeType;
      }
    },

    /**
     * Closes the Network diagram Zoom in Window and resets it's data.
     */
    close() {
      this.TOGGLE_NETWORK_DIAGRAM_ZOOM_IN(false);
    }
  },

  watch: {
    update() {
      this.getZoomInInfo();
    }
  }
};
</script>

<style scoped>
.details-network-diagram {
  zoom: 130%;
  margin-bottom: 25px;
}
.zoomInContainer{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/NetworkDiagramZoomIn.vue